import { string, shape, func, number, oneOfType } from "prop-types"
import Field from "./Field"
import { TextInput } from "@planningcenter/doxy-web"

const MedicalNotesField = ({ attendee, onChange, error, value, ...rest }) => {
  const { id: attendeeId } = attendee

  return (
    <Field label={"Medical Notes"} error={error} value={value} {...rest}>
      <TextInput
        id={`medicalNotes-${attendeeId}`}
        value={value || ""}
        onChange={({ target: { value } }) => onChange(value)}
        size="sm"
        placeholder="Medical notes"
      />
    </Field>
  )
}

MedicalNotesField.propTypes = {
  attendee: shape({
    id: oneOfType([string, number]),
  }),
  onChange: func,
  error: string,
  persistedValue: string,
  value: string,
}

export default MedicalNotesField
